import { withFingerprint } from 'utils/requests.utils'
import { ShallowResponse } from 'types/responses'
import { ApiClientV2Default } from 'utils/api-client/api-client.utils'

const BASE_URL = '/auth/sign_in'

export interface SignInParams {
  skipErrorNotific?: boolean
  otpAttempt?: string
}

export interface SignInData {
  magicLinkToken?: string | string[] | boolean
  profileType?: string
  email?: string
  password?: string
  otpAttempt?: string
}

export interface Session {
  redirectUrl: string
  success: boolean
  expiresAt: string
  refreshExpiresAt: string
  accessToken: string
  refreshToken: string
}

export const createSessionApi = ({ POST }: ApiClientV2Default) => ({
  signIn: (data: SignInData, params?: SignInParams) =>
    POST<ShallowResponse<Session>>(
      BASE_URL,
      {
        user: withFingerprint({ ...data }),
      },
      params
    ),
})

export type SessionApi = ReturnType<typeof createSessionApi>
export const { signIn } = createSessionApi(new ApiClientV2Default())
